import React from 'react'
import './kovin.css';

const DrMuthusamyMalaravan = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">National</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/muthusamyy.png" alt="Dr. Muthusamy Malaravan" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Dr. Muthusamy Malaravan</h3>
              <div className="name-underline"></div>
            </div>
          </div>



<div className="bio-container">
  <p className="bio">
    <strong>Dr. M. Malaravan</strong> is a Consultant Ophthalmologist at the Teaching Hospital, Jaffna, with advanced fellowship training in Anterior Segment and Intraocular Lens (IOL) surgery. He also serves as a Visiting Consultant Eye Surgeon to several regional and institutional healthcare facilities and contributes extensively to undergraduate and postgraduate medical education.

    <br /><br />

    He completed his medical education at the University of Jaffna, obtained his MD in Ophthalmology from the Postgraduate Institute of Medicine (PGIM), University of Colombo, and completed post-MD fellowship training at Aravind Eye Hospital and the Postgraduate Institute of Ophthalmology, a WHO Collaborating Centre in India. He is also a graduate of the Asia-Pacific Academy of Ophthalmology Leadership Development Programme.

    <br /><br />

    Dr. Malaravan is nationally and internationally recognised for his contributions to eye care, blindness prevention, and health system strengthening. In 2023, he founded the Centre of Ophthalmic Research in Eye Health (CORE Health Projects) and remains committed to equitable, accessible, and sustainable eye care services, with a focus on eliminating avoidable blindness.

    <br /><br />

    {/* <strong>Present Posts & Appointments</strong> */}
  </p>

  <ul className="bio-list">
    <li>Consultant Eye Surgeon (End Post), Department of Ophthalmology, Teaching Hospital, Jaffna</li>
    <li>Administrative Cover-up Consultant Eye Surgeon – DGH Mannar, DGH Kilinochchi & DGH Mullaitivu</li>
    <li>Visiting Consultant Eye Surgeon, Military Base Hospital, Security Forces Headquarters, Palaly, Jaffna</li>
    <li>Member, Board of Study in Ophthalmology – Postgraduate Institute of Medicine, Colombo</li>
    <li>MD Ophthalmology Examiner – Postgraduate Institute of Medicine, Colombo</li>
    <li>Module 1–4 MCQ Selection Committee Member – Postgraduate Institute of Medicine, Colombo</li>
    <li>External Examiner – Surgery, Faculty of Medicine, University of Jaffna</li>
    <li>External Examiner – BSc Nursing, Allied Health Sciences, Faculty of Medicine, University of Jaffna</li>
    <li>Visiting Lecturer – Surgery (Ophthalmology) & Allied Health Sciences, University of Jaffna</li>
    <li>Council Member – Sri Lanka Hypertension Society</li>
    <li>Council Member – University of Vavuniya</li>
    <li>Associate Member – Prevention of Blindness, Asia-Pacific Academy of Ophthalmology</li>
    <li>Northern Province Coordinator & Sub-Focal Point – Vision 2020, Sri Lanka</li>
    <li>Working Committee Member (Northern Province) – Glaucoma Interest Group, Sri Lanka</li>
    <li>Chief Consultant & Patron – Northern Province Consortium of Organizations for Differently Abled (NPCODA)</li>
    <li>Chief Consultant – Organization for Rehabilitation of the Handicapped (ORHAN)</li>
    <li>Patron – Jaffna Blind Association</li>
    <li>Advisory Board Member – Nuffield Deaf and Blind School</li>
    <li>Committee Member – Community Based Rehabilitation Planning Unit, Ministry of Health, Northern Province</li>
    <li>Committee Member – Provincial Health Planning, Ministry of Health, Northern Province</li>
    <li>Consultant – Visual Rehabilitation & Differently Abled Sports, Northern Province</li>
    <li>Member – District Vision 2020 & District Visual Rehabilitation Committees, Jaffna</li>
    <li>Member – Associate Medical Specialist Forum, Sri Lanka</li>
    <li>Member – Vavuniya Professional Association</li>
  </ul>

  <div className="bio-decoration"></div>
</div>




        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
            <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default DrMuthusamyMalaravan;